/**
 * Adds a Handlebars helper called `t` for use with i18next.
 *
 * @example
 *   {{t 'app_base.components.foo.bar' baz='quux'}}
 *
 * @see http://i18next.com
 * @see https://github.com/recipher/ember-cli-i18next/blob/master/app-addon/helpers/i18next.js
 */
Handlebars.registerHelper('t', function (key, options) {
  'use strict'

  var translation = i18next.t(key, options.hash)
  return new Handlebars.SafeString(translation)
})
